import css from './Visibility.module.css';

type VisibilityProps = {
  visible: boolean;
  renderHidden?: boolean;
  children: React.ReactNode;
};

const Visibility = ({ visible, renderHidden, children }: VisibilityProps) => {
  if (!visible && !renderHidden) {
    return <></>;
  }

  if (!visible) {
    return <span className={css.renderHidden}>{children}</span>;
  }

  return <>{children}</>;
};

export default Visibility;
